import React, { useEffect } from "react";
import { UserProvider } from "./contexts/UserContext";
import { UserPlanProvider } from "./contexts/UserPlanContext";
import { FeatureFlagsProvider } from "./contexts/FeatureFlagsContext";
import { TutorialProvider } from "./contexts/TutorialContext";
import useAffiliateTracker from "./hooks/useAffiliateTracker";
import useAffiliateQualification from "./hooks/useAffiliateQualification";
import { Capacitor } from "@capacitor/core";
import { Purchases } from "@revenuecat/purchases-capacitor";
import { ThemeProvider as LesVitaThemeProvider } from './contexts/ThemeContext'; // dark/light
import ThemeProvider from "./theme/ThemeProvider";    
import useNotifications from "./hooks/useNotifications";
import { UserProfileProvider } from "./contexts/UserProfileContext.jsx";
import { LiveWorkoutProvider } from "./contexts/LiveWorkoutContext.jsx";

const useRevenueCat = () => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const init = async () => {
      const platform = Capacitor.getPlatform();
      try {
        await Purchases.configure({
          apiKey:
            platform === "android"
              ? "goog_aGHmEcmvoitMIDrQaVZeRIZPvbk"
              : "appl_LAyIsnWqqaeJwibfpYnmdCuPUiF",
          appUserID: null,
        });
        // Expõe estado de prontidão do RevenueCat p/ o paywall (evita botão mudo).
        if (typeof window !== "undefined") window.__RC_READY__ = true;
      } catch (e) {
        console.error("[RevenueCat] Erro ao configurar:", e);
        // Falha de configuração fica VISÍVEL p/ o SubscribeButton desabilitar a compra.
        if (typeof window !== "undefined") window.__RC_READY__ = false;
      }
    };

    init();
  }, []);
};

const InnerProviders = ({ children }) => {
  useAffiliateTracker();
  // Vive AQUI, e não em PlataformaPessoal, por dois motivos: já está dentro do
  // UserProvider (tem uid e objectives) e este arquivo não pertence ao
  // redesign — a integração do programa não disputa linhas com as telas que
  // estão sendo reescritas.
  useAffiliateQualification();
  useRevenueCat();
  useNotifications();
  // O MonetizacaoHost (anúncios + funil do Premium) mora no AppRoutes, dentro
  // do <Router>: aqui, fora dele, a tela de planos lançava no useNavigate e a
  // compra virava tela preta.
  return children;
};

const AppProviders = ({ children }) => {
  return (
    <LesVitaThemeProvider>
      <UserProvider>
        <ThemeProvider>
          <FeatureFlagsProvider>
            <UserPlanProvider>
              <TutorialProvider>
                <UserProfileProvider>
                  <LiveWorkoutProvider>
                    <InnerProviders>{children}</InnerProviders>
                  </LiveWorkoutProvider>
                </UserProfileProvider>
              </TutorialProvider>
            </UserPlanProvider>
          </FeatureFlagsProvider>
        </ThemeProvider>
      </UserProvider>
    </LesVitaThemeProvider>
  );
};

export default AppProviders;